/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Richtextlinkaddress3Inputs */

const en_richtextlinkaddress3 = /** @type {(inputs: Richtextlinkaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Web address or email`)
};

const de_richtextlinkaddress3 = /** @type {(inputs: Richtextlinkaddress3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Webadresse oder E-Mail`)
};

/**
* | output |
* | --- |
* | "Web address or email" |
*
* @param {Richtextlinkaddress3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const richtextlinkaddress3 = /** @type {((inputs?: Richtextlinkaddress3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Richtextlinkaddress3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_richtextlinkaddress3(inputs)
	return de_richtextlinkaddress3(inputs)
});
export { richtextlinkaddress3 as "richTextLinkAddress" }